import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "@/App.vue";
import { createPinia } from "pinia";
import { fetchSettings, searchPosts } from "@/fetch";
import { messages } from "@/locales";
import {
  useItemStore,
  initializeSessionStorage,
  loadMoreHandler,
  sessionStorageListener,
} from "@/itemStore";

const lang = document.documentElement.lang.split("_")[0];
const posts = document.getElementById("dynamic-archive-posts") as HTMLElement;

if (posts != undefined) {
  const type = posts.dataset.type;
  if (type != undefined) {
    // Create i18n instance with options
    const i18n = createI18n({
      legacy: false,
      locale: lang, // set locale
      fallbackLocale: "en", // set fallback locale
      messages, // set locale messages
    });

    const app = createApp(App);
    app.use(createPinia());
    app.use(i18n);

    const itemStore = useItemStore();

    // Initialize from storage.
    initializeSessionStorage(type, lang);
    loadMoreHandler();
    sessionStorageListener();

    // Read filter settings from elements with "data-taxonomy" attributes.
    document.querySelectorAll<HTMLElement>("[data-taxonomy]").forEach((element) => {
      if (element.id !== undefined && element.dataset.taxonomy !== undefined) {
        itemStore.addTaxonomy(
          element.id,
          element.dataset.taxonomy,
          element.dataset.type ?? "button",
          element.dataset.placeholder ?? "",
          element.dataset.root ?? ""
        );
      }
    });

    // Look for and bind extra filter navigation buttons.
    document.querySelectorAll<HTMLElement>("[data-target]").forEach((element) => {
      if (element.dataset.target !== undefined) {
        const target = element.dataset.target;
        const root = element.dataset.root ?? "";
        const term = element.dataset.term ?? "";
        element.addEventListener("click", () => {
          if (root !== "") {
            itemStore.setTaxonomyRoot(target, root);
          }
          if (term !== "") {
            itemStore.setFilter(target, term);
          }
          // Reset active class.
          document.querySelectorAll<HTMLElement>(`[data-target='${target}']`).forEach((clear) => {
            clear.classList.remove("active");
          });
          element.classList.add("active");
        });
      }
    });

    fetchSettings().then(() => {
      searchPosts().then(() => {
        console.debug("Loaded default posts.");
      });
    });

    // Fetch default posts.

    app.mount(posts);
  }
}
